var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isValidInput)?_c('span',{class:_vm.cssClass,staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(_vm.formattedDate))]):_c('v-icon',[_vm._v("remove")])}
var staticRenderFns = []

export { render, staticRenderFns }